export default __webpack_public_path__ + "static/media/Restorative Ring.aacb5a1e.jpg";